import AllProjectCircle from "./AllProjectCircle";
import HeroSection from "./HeroSection";
import PricingCard from "./PricingCard";
import styled from "styled-components";
import Product from "./Product";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import AllProjectCard from "./AllProjectCard";
import AllProjectTry from "./AllProjectTry";
import {
  BarChart3,
  Brain,
  Settings,
  LineChart,
  Cog,
  GitFork,
} from "lucide-react";
import ImpactSection from "./ImpactSection";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import Navbar from "../../components/Navbar";
import SpeedDialMenu from "../../components/SpeedDialMenu";
import Footer from "../../components/Footer";
import LogoP from "../../assets/LogoImage.png";
import PricingPage from "../Pricing";
import Chatbot from "../../components/Chatbot";

const LandingPage = () => {
  //const pages = ["Home", "Product", "Pricing", "Contact Us"];
  const pages = ["Home", "Product", "Contact Us"];
  const userOptions = ["Profile", "Settings", "Logout"];

  const handlePageSelect = (page) => {
    if (!page) {
      console.error("Page is null or undefined");
      return;
    }

    const sectionId = page.toLowerCase().replace(/\s+/g, "-");
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, "", `/${sectionId}`);
    } else {
      console.warn(`Section with ID '${sectionId}' not found.`);
      window.location.href = `/${sectionId}`;
    }
  };

  const handleUserOptionSelect = (option) => {};

  // Sample JSON Data
  const jsonData = [
    {
      icon: <Settings size={24} color="#3182ce" />,
      label: "Task & Project Management",
    },
    {
      icon: <Settings size={24} color="#3182ce" />,
      label: "Gantt Charts & Kanban Boards",
    },

    { icon: <Settings size={24} color="#3182ce" />, label: "Sprint" },
    { icon: <Settings size={24} color="#3182ce" />, label: "Custom Workflows" },

    { icon: <Settings size={24} color="#3182ce" />, label: "Agile Workflow" },
    { icon: <Settings size={24} color="#3182ce" />, label: "Roadmap" },
    {
      icon: <Settings size={24} color="#3182ce" />,
      label: "AI-Powered Insights & Reports",
    },
    {
      icon: <Settings size={24} color="#3182ce" />,
      label: "Time Tracking and  Productivity",
    },
    { icon: <Settings size={24} color="#3182ce" />, label: "TimeLine" },
    { icon: <Settings size={24} color="#3182ce" />, label: "Analytics" },

    { icon: <Settings size={24} color="#3182ce" />, label: "Report" },

    {
      icon: <Settings size={24} color="#3182ce" />,
      label: "Team Collaboration",
    },
  ];

  const pricingData = [
    {
      tier: "free",
      price: "0",
      description:
        "Perfect for getting started with basic features and functionality.",
      features: [
        "Basic Analytics",
        "Up to 5 Projects",
        "Community Support",
        "2GB Storage",
        "API Access",
      ],
      buttonText: "Signup for free",
    },
    {
      tier: "pro",
      price: "8",
      description: "Advanced features for professionals who need more power.",
      features: [
        "Advanced Analytics",
        "Unlimited Projects",
        "Priority Support",
        "Team Collaboration",
        "Custom Integrations",
      ],
      buttonText: "Go to pro",
      isHighlighted: true,
    },
    {
      tier: "business",
      price: "16",
      description: "Enterprise-grade solution for large scale operations.",
      features: [
        "Enterprise Analytics",
        "Dedicated Support",
        "Custom Solutions",
        "Advanced Security",
        "SLA Guarantee",
      ],
      buttonText: "Go to Business",
    },
  ];

  const handleWhatsAppClick = () => {
    window.open(
      `https://wa.me/+919205891253?text=Hi%20Prakalpa.ai!%20I%20found%20this%20website%20useful.`,
    );
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+919205891253";
  };

  const actions = [
    {
      icon: <WhatsAppIcon sx={{ color: "green" }} />,
      name: "whatsApp",
      onClick: () => handleWhatsAppClick(),
    },
    {
      icon: <PhoneInTalkIcon sx={{ color: "#3CCEC9" }} />,
      name: "Phone",
      onClick: () => handlePhoneClick(),
    },
  ];

  return (
    <>
      <Navbar
        // logo="Prakalpa.ai"
        logo={LogoP}
        pages={pages}
        userOptions={userOptions}
        onPageSelect={handlePageSelect}
        onUserOptionSelect={handleUserOptionSelect}
      />
      <div id="home">
        <HeroSection />
        {/* <AllProjectCircle data={jsonData} /> */}
        {/* <AllProjectCard /> */}
        <AllProjectTry />
        <ImpactSection />
      </div>
      <div id="product">
        <Product />
      </div>
      {/* <div id="about-us">
        <AboutUs />
      </div> */}
      {/*  <div id="pricing">
        <PricingPage />
      </div> */}
      <div id="contact-us">
        <ContactUs />
      </div>

      <Footer />
      <div style={{ position: "fixed", bottom: "80px", right: "15px" }}>
        <SpeedDialMenu actions={actions} />
      </div>

      {/*  <Chatbot /> */}
    </>
  );
};

export default LandingPage;
